export const SetJobDetails = {
    Title: 'Set Job Details',
    TitleOperations: {
        uploadingImage: 'Uploading 1 image...'
    },
    SubTitles: {
        Comments: 'Comments'
    },
    Buttons: {
        Next: {
            label: 'Next'
        }
    },
    Errors: {
        Titles: {
            Error: 'Error!',
            jobCancelled: 'Job Cancelled'
        },
        Messages: {
            ServiceIsNotAvailiable: 'Thank you for inquring, but we don\'t currently service your area.',
            CannotAuthorizeCard: 'The charge was rejected by a payment system with a reason: the customer had to contact his bank.'
        }
    }
}



// WEBPACK FOOTER //
// ./src/localization/SetJobDetails.ts